export default __webpack_public_path__ + "static/media/person_2.1b490d2e.png";